<template>
  <div>
    <Filtro @filtro="makeFiltro"></Filtro>

    <List
      :filtro="filtro"
      :realizaFiltro="realizaFiltro"
      @filtroOk="finalizaFiltro"
      :subjectPermission="subjectPermission"
    ></List>
  </div>
</template>

<script>
import List from './../lists/ListAssociados';
import Filtro from './../filtros/FiltroAssociados';
export default {
  data() {
    return {
      realizaFiltro: false,
      filtro: null,
      subjectPermission: 'Associados',
    };
  },
  methods: {
    makeFiltro(filtro) {
      this.realizaFiltro = true;
      this.filtro = filtro;
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
  },
  components: {
    List,
    Filtro,
  },
};
</script>
